import { combineReducers } from '@reduxjs/toolkit';
import { routerReducer } from 'react-router-redux';

import {
  hotelsReducer,
  locationsReducer,
  roomsReducer,
  datesReducer,
  loginReducer,
  filtersReducer,
  condoFiltersReducer,
  navigationMenuReducer,
  benefitsReducer,
  marginatorReducer,
  currencyReducer,
  reservationsReducer,
  passwordReducer,
  travelHistoryReducer,
  myProfileReducer,
  trustYouReviewReducer,
  condoGuestsReducer,
  condosReducer,
  condosLocationPickerReducer,
  condoStrictDatesReducer,
  condoFlexibleDatePickerReducer,
  condoDetailsReducer,
  quotesReducer,
  reservationCancellationReducer,
  condosStaticReducer,
  carsReducer,
  carsLocationsReducer,
  carsDatesReducer,
  carsFiltersReducer,
  carsDriverReducer,
  weeksReducer,
  weeksLocationsReducer,
  weeksDatesReducer,
  weeksFiltersReducer,
  bookingManualSliceReducer,
  savedPropertiesReducer,
  compareReducer,
  crossSellReducer,
  certificatesReducer,
  certificatesWalletReducer,
  CertificateTemplateByIdReducer,
  CertificateByIdReducer,
  certificateTemplatesSearchReducer,
  certificateTermsReducer,
  walletDrawerReducer,

  // Activities (TRAV23 activities-front merge).
  activityReducer,
  activityFiltersReducer,
  activityLocationsReducer,
  activitySavedPropertyReducer,
  activityDetailsReducer,
  activityAvailabilityReducer,
  activityCheckoutReducer,
  activityQuestionReducer,
  activityReviewsReducer,
} from '@share/store/slices';

import {
  getawaysReducer,
  getawaysDetailsReducer,
  hotelDetailsReducer,
  reviewBookReducer,
  roomsSearchReducer,
  redeemCodeReducer,
  unitsSearchReducer,
  condoReviewBookReducer,
  condoRedeemCodeReducer,
  accountsReducer,
  accountSaveReducer,
  accountUsersReducer,
  accountUserSaveReducer,
  supportPhoneReducer,
  magazineReducer,
  travelLeaderReducer,
  condoPopularDestinationsReducer,
  popularDestinationsReducer,
  popularDestinationsOffersReducer,
  notificationBarReducer,
  getawayBookingReducer,
  currentUserReducer,
  getawayDatesReducer,
  personalDetailsReducer,
  webinarsReducer,
  carsDetailsReducer,
  carsReviewBookReducer,
  insuranceReducer,
  dashboardReportsReducer,
  weekDetailsReducer,
  weeksReviewBookReducer,
  weeksUnitsSearchReducer,
  luxuryHomesReducer,
  luxuryHomesSearchReducer,
  ashevillePlayReducer,
  blogsReducer,
} from '../slices';

import * as slices from '../slices';
import { insuranceQuoteReducer } from '../slices/insurance-quote';
import { luxuryHomesDetailsReducer } from '../slices/luxury-home-detail';

export const rootReducer = combineReducers({
  hotelsStore: hotelsReducer,
  locationsStore: locationsReducer,
  roomsStore: roomsReducer,
  datesStore: datesReducer,
  getawaysStore: getawaysReducer,
  getawaysDetailsStore: getawaysDetailsReducer,
  navigationMenuStore: navigationMenuReducer,
  filtersStore: filtersReducer,
  hotelDetailsStore: hotelDetailsReducer,
  reviewBookStore: reviewBookReducer,
  roomsSearchStore: roomsSearchReducer,
  trustYouReviewStore: trustYouReviewReducer,
  redeemCodeStore: redeemCodeReducer,
  condoGuestsStore: condoGuestsReducer,
  condosStore: condosReducer,
  condosStaticStore: condosStaticReducer,
  condosLocationPickerStore: condosLocationPickerReducer,
  condoStrictDatesStore: condoStrictDatesReducer,
  condoFlexibleDatePickerStore: condoFlexibleDatePickerReducer,
  condoDetailsStore: condoDetailsReducer,
  unitsSearchStore: unitsSearchReducer,
  condoReviewBookStore: condoReviewBookReducer,
  condoRedeemCodeStore: condoRedeemCodeReducer,
  accountsStore: accountsReducer,
  accountSaveStore: accountSaveReducer,
  accountUsersStore: accountUsersReducer,
  condoFiltersStore: condoFiltersReducer,
  loginStore: loginReducer,
  accountUserSaveStore: accountUserSaveReducer,
  routing: routerReducer,
  reservationCancellationStore: reservationCancellationReducer,
  supportPhoneStore: supportPhoneReducer,
  benefitsStore: benefitsReducer,
  magazineStore: magazineReducer,
  travelLeaderStore: travelLeaderReducer,
  condoPopularDestinationsStore: condoPopularDestinationsReducer,
  popularDestinationsStore: popularDestinationsReducer,
  popularDestinationsOffersStore: popularDestinationsOffersReducer,
  notificationBarStore: notificationBarReducer,
  getawayBookingStore: getawayBookingReducer,
  currentUserStore: currentUserReducer,
  getawayDatesStore: getawayDatesReducer,
  memberStory: slices.memberStoriesReducer,
  memberVideos: slices.memberVideosReducer,
  personalDetailsStore: personalDetailsReducer,
  marginatorStore: marginatorReducer,
  webinarsStore: webinarsReducer,
  insuranceStore: insuranceReducer,
  currencyStore: currencyReducer,
  compareStore: compareReducer,
  certificatesStore: certificatesReducer,
  certificatesWalletStore: certificatesWalletReducer,
  reservationsStore: reservationsReducer,
  passwordStore: passwordReducer,
  travelHistoryStore: travelHistoryReducer,
  myProfileStore: myProfileReducer,
  quoteStore: quotesReducer,
  insuranceQuoteStore: insuranceQuoteReducer,

  carsStore: carsReducer,
  carsLocationsStore: carsLocationsReducer,
  carsDatesStore: carsDatesReducer,
  carsFiltersStore: carsFiltersReducer,
  carsDriverStore: carsDriverReducer,
  carsDetailsStore: carsDetailsReducer,
  carsReviewBookStore: carsReviewBookReducer,
  dashboardReportsStore: dashboardReportsReducer,

  weeksStore: weeksReducer,
  weeksLocationsStore: weeksLocationsReducer,
  weeksDatesStore: weeksDatesReducer,
  weeksFiltersStore: weeksFiltersReducer,
  weeksDetailsStore: weekDetailsReducer,
  weeksReviewBookStore: weeksReviewBookReducer,
  weeksUnitsSearchStore: weeksUnitsSearchReducer,
  bookingManualStore: bookingManualSliceReducer,
  savedPropertiesStore: savedPropertiesReducer,
  luxuryHomesStore: luxuryHomesReducer,
  luxuryHomesSearchStore: luxuryHomesSearchReducer,
  luxuryHomesDetailsStore: luxuryHomesDetailsReducer,
  ashevillePlayStore: ashevillePlayReducer,
  blogsStore: blogsReducer,
  crossSellStore: crossSellReducer,
  CertificateTemplateByIdStore: CertificateTemplateByIdReducer,
  CertificateByIdStore: CertificateByIdReducer,
  certificateTemplatesSearchStore: certificateTemplatesSearchReducer,
  certificateTermsStore: certificateTermsReducer,
  walletDrawerStore: walletDrawerReducer,

  /**
   * Activities (TRAV23 activities-front merge). Filters and locations are activity-owned
   * rather than shared with `filtersStore` / `locationsStore`: the facet vocabularies and
   * the destination catalogues differ per vertical. Dates, rooms, currency and login are
   * deliberately shared, so a destination and date range carry across verticals.
   */
  activityStore: activityReducer,
  activityFiltersStore: activityFiltersReducer,
  activityLocationsStore: activityLocationsReducer,
  activitySavedPropertyStore: activitySavedPropertyReducer,
  activityDetailsStore: activityDetailsReducer,
  activityAvailabilityStore: activityAvailabilityReducer,
  activityCheckoutStore: activityCheckoutReducer,
  activityQuestionStore: activityQuestionReducer,
  activityReviewsStore: activityReviewsReducer,
});
